import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth.js';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { state } = useAuth();
  const location = useLocation();
  if (state.status === 'unknown') {
    return (
      <div className="text-center py-24 text-muted text-sm">checking session…</div>
    );
  }
  if (state.status === 'unauthed') {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
